import { type GridColDef } from "@mui/x-data-grid";
import moment from "moment";

import { PclProduct } from "features/public/Products/PCL/context/PclContextProvider";

import ConformanceClaimsCell from "./Cells/ConformanceClaims.cell";
import FullDetailsCell from "./Cells/FullDetails.cell";
import MaintenanceUpdateCell from "./Cells/MaintenanceUpdate.cell";
import SchemeCell from "./Cells/Scheme.cell";
import StatusCell from "./Cells/Status.cell";

export const pclColumns: GridColDef<PclProduct>[] = [
  {
    headerName: "VID",
    field: "v_id",
    sortable: true,
    flex: 0,
    valueFormatter: (value, row) => {
      const { from_cc_portal } = row;
      if (from_cc_portal) return "";
      return value;
    },
  },
  {
    headerName: "Vendor",
    field: "vendor_id_name",
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Product",
    field: "product_name",
    flex: 3,
    minWidth: 300,
  },
  {
    headerName: "CCTL",
    field: "assigned_lab_name",
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Certification Date",
    field: "certification_date",
    flex: 1,
    minWidth: 140,
    align: "center",
    valueFormatter: (value) => {
      return value && moment(value).utc().format("MM/DD/YYYY");
    },
  },
  {
    headerName: "Kickoff Date",
    field: "kicked_off_date",
    flex: 1,
    minWidth: 110,
    align: "right",
    valueFormatter: (value) => {
      return value && moment.utc(value).format("MM/DD/YYYY");
    },
  },
  {
    headerName: "Status",
    field: "status_sort",
    flex: 1,
    minWidth: 120,
    align: "left",
    headerAlign: "center",
    renderCell: ({ row }) => <StatusCell row={row} />,
  },
  {
    headerName: "Conformance Claims",
    field: "project_pp_product.pp.pp_short_name",
    sortable: false,
    flex: 1,
    minWidth: 170,
    renderCell: ({ row }) => <ConformanceClaimsCell row={row} />,
  },
  {
    headerName: "Assurance Maintenance Date",
    field: "am_sort",
    flex: 2,
    minWidth: 150,
    align: "center",
    valueFormatter: (value, row) => {
      const { status_sort: status } = row;
      if (status === "Archived" || !value) return "";

      return moment.utc(value).format("MM/DD/YYYY");
    },
  },
  {
    headerName: "Maintenance Update",
    sortable: false,
    field: "project_maintenance_product.headerName",
    flex: 3,
    minWidth: 300,
    renderCell: (rowData) => <MaintenanceUpdateCell row={rowData.row} />,
  },
  {
    headerName: "Scheme",
    field: "submitting_country_id_code",
    flex: 1,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    renderCell: ({ row }) => (
      <SchemeCell
        countryCode={row.submitting_country_id_code}
        countryName={row.submitting_country_id_code}
      />
    ),
  },
  {
    headerName: "",
    field: "_actions",
    sortable: false,
    flex: 0,
    minWidth: 130,
    renderCell: ({ row }) => <FullDetailsCell row={row} />,
  },
];
